import { EnumPaths } from "../utils/navigation";
export const defaultMenuType = "menu-hidden"; // 'menu-default', 'menu-sub-hidden', 'menu-hidden';
export const defaultStartPath = `/${EnumPaths.ROOT}/${EnumPaths.HOME}`;
export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const NOTIFICATION_DISPLAY_TIME = 5000;
